import { Component } from '@angular/core';
import { AviInvoiceListItem } from 'src/app/avi-invoice-list-item';
import { HttpService } from 'src/app/service/http.service';
import { ToastMessageService } from '../../toast-message.service';
import { ApiError } from 'src/app/api-error';

@Component({
  selector: 'app-avi-invoices',
  templateUrl: './avi-invoices.component.html',
  styleUrls: ['./avi-invoices.component.css']
})
export class AviInvoicesComponent {

  invoices: AviInvoiceListItem[] = [];

  constructor(
    private httpService: HttpService,
    private toastService: ToastMessageService
  ) {
    httpService.getAllAviInvoices().subscribe(res => {
      this.invoices = res;
    });
  }

  downloadPdf(invoice: AviInvoiceListItem){
    this.httpService.getAvilInvoiceFileById(invoice.id).subscribe(res => {
      const binaryData = [];
      binaryData.push(res);
      this.downloadFile(binaryData, "Facture_" + invoice.invoiceNumberStr + ".pdf");
    }, error => {
      this.toastService.addApiError(new ApiError(error));
    });
  }



  downloadFile(bytes: BlobPart[], fileName: string) {
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob(bytes, { type: 'blob' }));
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
}